*,
::after,
::before {
  box-sizing: border-box;
}

:where(button) {
  all: unset;
  display: flex;
  user-select: none;
  touch-action: manipulation;
  -webkit-user-drag: element;
}

:host {
  display: grid;
  grid-template-rows: min-content;
}

.header {
  display: flex;
  gap: var(--ch-tree-view-item-gap);
  align-items: center;
}
.header--disabled {
  pointer-events: none;
}
.header--disabled > .action {
  --ch-start-img: var(--ch-start-img--disabled, var(--ch-start-img--base));
  --ch-end-img: var(--ch-end-img--disabled, var(--ch-end-img--base));
}
.header:hover > .action {
  --ch-start-img: var(--ch-start-img--hover, var(--ch-start-img--base));
  --ch-end-img: var(--ch-end-img--hover, var(--ch-end-img--base));
}
.header:active > .action {
  --ch-start-img: var(--ch-start-img--active, var(--ch-start-img--base));
  --ch-end-img: var(--ch-end-img--active, var(--ch-end-img--base));
}
.header:focus > .action {
  --ch-start-img: var(
    --ch-start-img--focus,
    var(--ch-start-img--active, var(--ch-start-img--base))
  );
  --ch-end-img: var(
    --ch-end-img--focus,
    var(--ch-end-img--active, var(--ch-end-img--base))
  );
}

.line {
  --inset-inline-start: calc(var(--ch-tree-tab-size) * (var(--level) - 1) - var(--parent-offset, 0px) + var(--ch-tree-view-item-custom-padding-inline-start) + var(--ch-tree-view-item__expandable-button-size) * 0.5 + var(--ch-tree-view-item__line--inset-inline-start));
  position: absolute;
  inset-inline-start: var(--inset-inline-start);
  inline-size: calc(var(--ch-tree-view-item-indentation) - var(--inset-inline-start) - var(--ch-tree-view-item__line--inset-inline-end));
  block-size: 1px;
  border: 0 dashed color-mix(in srgb, currentColor 65%, transparent);
  border-block-end-width: 1px;
  pointer-events: none;
  content-visibility: hidden;
  z-index: 1;
}

.last-all-line {
  inset-block-start: 0;
  height: calc(100% - var(--ch-tree-view-item-distance-to-checkbox));
  border-inline-start-width: 1px;
  border-end-start-radius: 2px;
}

.last-line {
  inset-block-start: 0;
  height: 100%;
  border-inline-start-width: 1px;
  border-inline-start-style: solid;
  border-block-end: unset;
}

.expandable-button,
.expandable-button-decorative::before {
  display: grid;
  place-items: center;
  inline-size: var(--ch-tree-view-item__expandable-button-size);
  block-size: var(--ch-tree-view-item__expandable-button-size);
  z-index: 1;
  cursor: pointer;
}

.expandable-button-decorative::before {
  content: "";
  background-color: currentColor;
  -webkit-mask: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none"><path d="M16.5 5L8.7 12.7L1 5" stroke="%23000" stroke-width="1.2" stroke-linecap="round"/></svg>') 50% 50%/calc(100% - 4px) calc(100% - 4px) no-repeat;
  cursor: unset;
}
.expandable-button-decorative--collapsed::before {
  transform: rotate(-90deg);
}
.expandable-button::before {
  content: "";
  inline-size: calc(100% - 4px);
  block-size: calc(100% - 4px);
  background-color: currentColor;
  -webkit-mask-size: calc(var(--ch-tree-view-item__expandable-button-size) - 4px);
}
.expandable-button--collapsed::before {
  -webkit-mask-image: url('data:image/svg+xml,<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M14.15,8.5H8.54v5.61h-1V8.5H1.93v-1H7.54V1.89h1V7.5h5.61Z"/></svg>');
}
.expandable-button--expanded::before {
  -webkit-mask-image: url('data:image/svg+xml,<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M14.15,8.5H1.93v-1H14.15Z"/></svg>');
}

.checkbox {
  inline-size: var(--ch-tree-view-item__checkbox-size);
  --ch-checkbox__container-size: var(--ch-tree-view-item__checkbox-size);
}

.action {
  --ch-start-img: var(--ch-start-img--base);
  --ch-end-img: var(--ch-end-img--base);
  display: grid;
  grid-template: "start-img text"/max-content 1fr;
  gap: var(--ch-tree-view-item-gap);
  align-items: center;
  block-size: 100%;
  flex: 1;
  cursor: pointer;
}
.action--end-img {
  grid-template: "start-img text end-img"/max-content 1fr max-content;
}

.edit-caption {
  grid-area: text;
  inline-size: 100%;
  block-size: 100%;
  padding: 0;
  margin: 0;
  background-color: unset;
  border: unset;
  color: unset;
  font: unset;
  outline: unset;
}

.pseudo-img--start::before,
.pseudo-img--end::after,
.img {
  display: block;
  inline-size: var(--ch-tree-view-item__image-size);
  block-size: var(--ch-tree-view-item__image-size);
  content-visibility: auto;
  contain-intrinsic-size: auto var(--ch-tree-view-item__image-size);
}

.pseudo-img--start::before,
.start-img {
  content: "";
  grid-area: start-img;
}

.pseudo-img--end::after,
.end-img {
  content: "";
  grid-area: end-img;
}

.start-img-type--background::before {
  background: no-repeat center/var(--ch-tree-view-item__background-image-size) var(--ch-start-img);
}

.end-img-type--background::after {
  background: no-repeat center/var(--ch-tree-view-item__background-image-size) var(--ch-end-img);
}

.start-img-type--mask::before {
  -webkit-mask: no-repeat center/var(--ch-tree-view-item__background-image-size) var(--ch-start-img);
  background-color: currentColor;
}

.end-img-type--mask::after {
  -webkit-mask: no-repeat center/var(--ch-tree-view-item__background-image-size) var(--ch-end-img);
  background-color: currentColor;
}

.downloading {
  inline-size: 0.75em;
  block-size: 0.75em;
  margin-inline: 8px 2px;
  border: 2px solid currentColor;
  border-inline-start-color: transparent;
  border-radius: 50%;
  opacity: 0.75;
  animation: spin 1s linear infinite, avoid-flickering 75ms;
}

@keyframes avoid-flickering {
  0%, 100% {
    display: none;
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.expandable {
  display: grid;
  grid-auto-rows: min-content;
  position: relative;
}
.expandable--lazy-loaded {
  content-visibility: auto;
  contain-intrinsic-size: auto 100px;
}

.expandable--collapsed {
  display: none;
  overflow: hidden;
}